module.exports = __webpack_public_path__ + "static/img/10.158aa90.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fu_shen/10.png
// module id = JkTB
// module chunks = 0